import type { FaqItem } from "@/components/PageFaq";

export const HOME_FAQ: FaqItem[] = [
  {
    q: "What is the fastest flying mount in Palworld?",
    a: "Jetragon is the fastest flying mount in Palworld, followed by Frostallion, Beakon and Ragnahawk. The Pal Stars mounts table ranks every rideable Pal by flying, ground and swim speed.",
  },
  {
    q: "How many Pals are in Palworld?",
    a: "Pal Stars indexes officially confirmed Palworld Pals and subspecies, including legendaries such as Jetragon, Frostallion, Necromus and Paladius.",
  },
  {
    q: "How does Palworld breeding work?",
    a: "Place two compatible Pals of opposite genders on a Breeding Farm with a cake to produce an egg. The offspring depends on the parents' combined breed power, and the Pal Stars breeding calculator maps every valid pairing forwards and in reverse.",
  },
  {
    q: "How do you breed Jetragon in Palworld?",
    a: "Breed Blazamut × Suzaku, or Anubis × Astegon, at a Breeding Farm with a Grade S Cake to produce a Jetragon egg. Parents at 4-5 condensed stars roughly halve the hatch time.",
  },
  {
    q: "What is the best Pal in Palworld?",
    a: "Jetragon is the strongest all-round Pal in Palworld for mount speed and raw attack, followed by Anubis, Necromus, Frostallion and Paladius for combat and base utility.",
  },
  {
    q: "Is Pal Stars an official Palworld site?",
    a: "No. Pal Stars is a free unofficial fan wiki and database. Palworld is developed and published by Pocketpair, Inc., and the Palworld Trading Card Game is published by Bushiroad.",
  },
];